export const toggleSidebar = (enabled) => {
  return {
    type: 'TOGGLE_SIDEBAR',
    enabled,
  }
}

export const setGameList = (view) => {
  return {
    type: 'SET_GAME_LIST',
    view,
  }
}

export const openChallengeModal = () => {
  return {
    type: 'OPEN_CHALLENGE_MODAL',
  }
}

export const closeChallengeModal = () => {
  return {
    type: 'CLOSE_CHALLENGE_MODAL',
  }
}

export const openViewChallengeModal = (id) => {
  return {
    type: 'OPEN_VIEW_CHALLENGE_MODAL',
    id,
  }
}

export const closeViewChallengeModal = () => {
  return {
    type: 'CLOSE_VIEW_CHALLENGE_MODAL',
  }
}

export const openAlertModal = (message) => {
  return {
    type: 'OPEN_ALERT_MODAL',
    message,
  }
}

export const closeAlertModal = () => {
  return {
    type: 'CLOSE_ALERT_MODAL',
  }
}

export const openViewRequestModal = ({ id, name }) => {
  return {
    type: 'OPEN_VIEW_REQUEST_MODAL',
    id,
    name,
  }
}


export const closeViewRequestModal = () => {
  return {
    type: 'CLOSE_VIEW_REQUEST_MODAL',
  }
}

export const setFriendList = (list) => {
  return {
    type: 'SET_FRIEND_LIST',
    list,
  }
}



/** WEBPACK FOOTER **
 ** ./src/actions/layout.js
 **/